const PROD_PAGES = {
  '/sports': () => import('./configModules/sports'),
  '/results': () => import('./pages/results'),
  '/live': () => import('./configModules/live'),
  '/e-sports': () => import('./configModules/e-sports'),
  '/personal-office': () => import('./configModules/personal-office'),
  '/login': () => import('./pages/login'),
  '/registracija': () => import('./configModules/registracija'),
  '/forgot-password': () => import('./pages/forgot-password'),
  '/casino': () => import('./configModules/casino'),
  '/instant-games': () => import('./configModules/instant-games'),
  '/promos': () => import('./configModules/promos'),
  '/keno': () => import('./pages/keno'),
  '/loto': () => import('./pages/lottery'),
  '/bet-games': () => import('./pages/betgames'),
  '/sport-poker': () => import('./pages/sport-poker'),
  '/virtual-sports': () => import('./configModules/virtual-sports'),
  '/responsible-gaming': () => import('./pages/responsible-gaming'),
  '/bets': () => import('./pages/bets-redirect'),
  '/help-center': () => import('./pages/help-center'),
  '/cookie-declaration': () => import('./pages/cookie-declaration'),
  '/settings': () => import('./pages/settings')
};

const DEV_PAGES = {};

export const FALLBACK_PAGES =
  process.env.NODE_ENV === 'development'
    ? { ...PROD_PAGES, ...DEV_PAGES }
    : PROD_PAGES;
